// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__mbhR1","header":"PatientBlock_header__140JY","label":"PatientBlock_label__1352n","option":"PatientBlock_option__2cxmr"};